
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon-tabler icons-tabler-outline icon-tabler-grain",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","stroke":"none"}}),_c('path',{attrs:{"d":"M3.5 9.5a1 1 0 102 0 1 1 0 10-2 0M8.5 4.5a1 1 0 102 0 1 1 0 10-2 0M8.5 14.5a1 1 0 102 0 1 1 0 10-2 0M3.5 19.5a1 1 0 102 0 1 1 0 10-2 0M13.5 9.5a1 1 0 102 0 1 1 0 10-2 0M18.5 4.5a1 1 0 102 0 1 1 0 10-2 0M13.5 19.5a1 1 0 102 0 1 1 0 10-2 0M18.5 14.5a1 1 0 102 0 1 1 0 10-2 0"}})])
          )
        }
      }
    